import React, { FC }                                         from 'react';
import { Auth0Provider, Auth0ProviderOptions }               from '@auth0/auth0-react';
import { ENVIRONMENT_IS_PRODUCTION, ENVIRONMENT_IS_STAGING } from '../../../../constants/SystemEnums';

enum AUTH_ZERO_ENV_IDS {
	TEST = 'qd52Cjvv7YSzx1MOiOkRngt8XNjvlr01',
	PROD = '8EYtz1SEQAWR4HqUpLsjPrgeAyn6M2fr',
}

enum AUTH_ZERO_ENV_DOMAINS {
	TEST = 'corval-dev.us.auth0.com',
	PROD = 'corval-prod.us.auth0.com',
}

enum AUTH_ZERO_ENV_AUDIENCE {
	TEST = 'https://app-corval-dev',
	PROD = 'https://app-corval-prod',
}

enum AUTH_ZERO_ERROR_FLAGS {
	LOGIN_REQUIRED   = 'login_required',
	CONSENT_REQUIRED = 'consent_required',
}

interface Props {}

const defaultProps: Props = {}

const env                 = ( ENVIRONMENT_IS_PRODUCTION || ENVIRONMENT_IS_STAGING ) ? 'PROD' : 'TEST';
const getAuthZeroClientId = () => AUTH_ZERO_ENV_IDS[ env ];
const getAuthZeroDomain   = () => AUTH_ZERO_ENV_DOMAINS[ env ];
const getAuthZeroAudience = () => AUTH_ZERO_ENV_AUDIENCE[ env ];

const AuthZeroProvider: FC<Props> = ( props ) => {
	
	let providerConfig: Auth0ProviderOptions = {
		clientId:         getAuthZeroClientId(),         // Auth0 client to utilize, per environment
		domain:           getAuthZeroDomain(),           // Auth0 domain to utilize, per environment
		audience:         getAuthZeroAudience(),         // Auth0 audience, per environment
		scope:            'openid offline_access email', // 'offline_access' is required for refresh_tokens to appear...
		cacheLocation:    'localstorage',                // allow us to save the session across tab / browser closures
		useRefreshTokens: true,                          // allow access tokens to be updated via refresh tokens
	}
	
	return (
		<Auth0Provider { ...providerConfig }>
			
			{ props.children }
		
		</Auth0Provider>
	);
	
}

AuthZeroProvider.defaultProps = defaultProps;

export {
	AuthZeroProvider,
	getAuthZeroClientId,
	getAuthZeroDomain,
	getAuthZeroAudience,
	AUTH_ZERO_ERROR_FLAGS,
}
